export default __webpack_public_path__ + "static/media/iconeGas.563a32ce.png";